<template>
  <div class="configure flex-grow-1 flex-shrink-0" :class="customCssClass">
    <div class="container">
      <div @click="handleClick" class="form-control p-5 contract">
        <div v-if="shouldShowLogo" class="w-full text-center mb-5">
          <img :style="assetType.slug === 'framework-agreement-sow' ? 'width: 150px' : ''" src="/images/gsanda.jpg" />
        </div>

        <div v-if="assetType.slug === 'framework-agreement'" class="mb-5">
          Please click <InertiaLink target="_blank" :href="route('framework-agreement-intro')">here</InertiaLink> to see guidance notes on this document.
        </div>

        <div v-for="(page, index) in contract.pages" :key="index" class="page">
          <component
            :is="block.type"
            v-for="(block, index) in page.blocks"
            :key="index"
            :block="block"
            :blocks="blocks"
            :definitions="definitions"
            :asset="asset"
            :show-actions="showActions"
          />
        </div>

        <Signatures
          class="mt-5 pt-5"
          v-if="signatures.length"
          :signatures="signatures"
        />

        <Definition
          v-if="definition"
          @closeDefinitionPopup="closeDefinitionPopup"
          :definitionContent="definitionContent"
          :definitionPosition="definitionPosition"
        />

        <div v-if="isTerms">
          <p>
            Please review our Use Terms
            <a :href="route('use-terms')" target="_blank">here</a> and then sign
            below to confirm your agreement to them.
          </p>
        </div>
      </div>

      <Schedule
        v-if="schedule"
        @closeSchedulePopup="() => (schedule = false)"
        :scheduleContent="scheduleContent"
      />
    </div>
  </div>
</template>

<script>
import contractComponents from "@/Mixins/contractComponents";
import popupMixin from "@/Mixins/popupMixin";
import Signatures from "@/Pages/Asset/Contract/Signatures/Signatures";

export default {
  mixins: [contractComponents, popupMixin],

  components: {
    Signatures,
  },

  props: {
    asset: Object,
    assetType: Object,
    review: {
      type: Boolean,
      default: false
    },
    showActions: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      contract: this.asset.contract.contract,
      blocks: this.asset.contract.contract_blocks
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.$emit("loaded");
    });
  },

  computed: {
    signatures() {
      return this.asset.signatures;
    },

    customCssClass() {
      if (this.assetType.slug === "one-nda") return "one-nda";
      // if (this.assetType.slug === 'non-disclosure-agreement' ) return 'gsa-nda'
      return "";
    },

    isTerms() {
      if (this.assetType.slug === "clausify-use-terms") return true;
      return false;
    },

    shouldShowLogo() {
      if (
        this.assetType.slug === "non-disclosure-agreement" ||
        this.assetType.slug === "framework-agreement" ||
        this.assetType.slug === "static-gsa-disclaimer" ||
        this.assetType.slug === "framework-agreement-sow"
      )
        return true;
      return false;
    }
  }
};
</script>
